export default function About() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Licensed & Insured',
      description: 'CSLB #1121944 - Fully licensed and insured for your peace of mind'
    },
    {
      icon: 'ri-award-line',
      title: 'Expert Craftsmanship',
      description: 'Years of experience delivering quality construction and repair services'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Professional Service',
      description: 'Dedicated to customer satisfaction and exceptional results'
    },
    {
      icon: 'ri-time-line',
      title: 'Timely Completion',
      description: 'Projects completed on schedule with attention to detail'
    }
  ];

  return (
    <section id="about" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Why Choose PCS Marine Construction?
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              At PCS Marine Construction, we bring premier contracting services to every project. Our comprehensive expertise spans dock replacement and repair, marine plumbing, and marine electrical services. As a licensed and insured contractor (CSLB #1121944), we're committed to delivering exceptional quality and professional service.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Whether you need a complete dock replacement, expert repairs, or specialized plumbing, mechanical, and electrical work, our team has the skills and experience to exceed your expectations. We pride ourselves on quality craftsmanship, attention to detail, and customer satisfaction.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#172554] text-white rounded-lg flex-shrink-0">
                    <i className={`${feature.icon} text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1">{feature.title}</h3>
                    <p className="text-sm text-gray-600">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/54c124f81b8e368fe8a1f7a37b0a79ed.jpeg"
                alt="PCS Dock Construction Team"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-yellow-500 text-gray-900 p-8 rounded-xl shadow-xl max-w-xs">
              <p className="text-4xl font-bold mb-2">25+</p>
              <p className="text-lg font-semibold">Years of Excellence</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
